var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "videoWrapper",
      staticClass: "gallery-video",
      class: { "gallery-modal__carousel-item": _vm.mode === "full" },
      on: {
        mouseenter: _vm.onMouseEnter,
        mousemove: _vm.onMouseEnter,
        mouseleave: _vm.onMouseLeave,
        touchend: _vm.onTap,
      },
    },
    [
      _vm.mode === "full"
        ? _c("picture", { attrs: { "data-type": "full" } }, [
            _c("source", {
              attrs: {
                media: "(min-width: 1440px)",
                "data-srcset-observer": `${_vm.item.image}?width=1200`,
              },
            }),
            _vm._v(" "),
            _c("source", {
              attrs: {
                media: "(min-width: 1200px) and (max-width: 1439px)",
                "data-srcset-observer": `${_vm.item.image}?width=1100`,
              },
            }),
            _vm._v(" "),
            _c("source", {
              attrs: {
                media: "(min-width: 992px) and (max-width: 1219px)",
                "data-srcset-observer": `${_vm.item.image}?width=1000`,
              },
            }),
            _vm._v(" "),
            _c("source", {
              attrs: {
                media: "(min-width: 768px) and (max-width: 991px)",
                "data-srcset-observer": `${_vm.item.image}?width=850`,
              },
            }),
            _vm._v(" "),
            _c("source", {
              attrs: {
                media: "(max-width: 768px)",
                "data-srcset-observer": `${_vm.item.image}?width=600`,
              },
            }),
            _vm._v(" "),
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.isPlaying === false &&
                    _vm.isFullscreen == false &&
                    _vm.mode !== "full",
                  expression:
                    "(isPlaying === false && isFullscreen == false && mode !== 'full')",
                },
              ],
              staticClass: "asset-img",
              attrs: {
                "data-src-observer": `${_vm.thumbnailPauseImage}?width=700`,
                fetchpriority: _vm.isPriority ? "high" : "low",
                width: _vm.item.imageWidth,
                height: _vm.item.imageHeight,
                alt: _vm.item.imageAlternativeText,
                "aria-label": _vm.item.imageAlternativeText,
              },
              on: { click: _vm.videoPlay },
            }),
          ])
        : _c("picture", { attrs: { "data-type": "list" } }, [
            _c("source", {
              attrs: {
                media: "(min-width: 1800px)",
                "data-srcset-observer": `${
                  _vm.item.image
                }?width=${_vm.getImageSrcSetSize("> 1800")}`,
              },
            }),
            _vm._v(" "),
            _c("source", {
              attrs: {
                media: "(min-width: 1440px) and (max-width: 1799px)",
                "data-srcset-observer": `${
                  _vm.item.image
                }?width=${_vm.getImageSrcSetSize("> 1440 && < 1799")}`,
              },
            }),
            _vm._v(" "),
            _c("source", {
              attrs: {
                media: "(min-width: 1200px) and (max-width: 1439px)",
                "data-srcset-observer": `${
                  _vm.item.image
                }?width=${_vm.getImageSrcSetSize("> 1200 && < 1439")}`,
              },
            }),
            _vm._v(" "),
            _c("source", {
              attrs: {
                media: "(min-width: 992px) and (max-width: 1199px)",
                "data-srcset-observer": `${
                  _vm.item.image
                }?width=${_vm.getImageSrcSetSize("> 992 && < 1199")}`,
              },
            }),
            _vm._v(" "),
            _c("source", {
              attrs: {
                media: "(min-width: 768px) and (max-width: 991px)",
                "data-srcset-observer": `${
                  _vm.item.image
                }?width=${_vm.getImageSrcSetSize("> 768px && < 991")}`,
              },
            }),
            _vm._v(" "),
            _c("source", {
              attrs: {
                media: "(min-width: 540px) and (max-width: 767px)",
                "data-srcset-observer": `${
                  _vm.item.image
                }?width=${_vm.getImageSrcSetSize("> 540 && < 767 x1")} 1x, ${
                  _vm.item.image
                }?width=${_vm.getImageSrcSetSize("> 540 && < 767 x2")} 2x`,
              },
            }),
            _vm._v(" "),
            _c("source", {
              attrs: {
                media: "(max-width: 539px)",
                "data-srcset-observer": `${
                  _vm.item.image
                }?width=${_vm.getImageSrcSetSize("< 539 x1")} 1x, ${
                  _vm.item.image
                }?width=${_vm.getImageSrcSetSize("< 539 x2")} 2x`,
              },
            }),
            _vm._v(" "),
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.isPlaying === false &&
                    _vm.isFullscreen == false &&
                    _vm.mode !== "full",
                  expression:
                    "(isPlaying === false && isFullscreen == false && mode !== 'full')",
                },
              ],
              staticClass: "asset-img",
              attrs: {
                fetchpriority: _vm.isPriority ? "high" : "low",
                loading: _vm.isPlaying == false ? "lazy" : "",
                "data-src-observer": `${_vm.item.image}?width=600`,
                width: _vm.item.imageWidth,
                height: _vm.item.imageHeight,
                alt: _vm.item.imageAlternativeText,
                "aria-label": _vm.item.imageAlternativeText,
              },
              on: { click: _vm.videoPlay },
            }),
          ]),
      _vm._v(" "),
      _c(
        "video",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.isPlaying ||
                _vm.isFullscreen ||
                (_vm.isPlaying == false && _vm.mode === "full"),
              expression:
                "isPlaying || isFullscreen || (isPlaying == false && mode === 'full')",
            },
          ],
          ref: "videoElem",
          staticClass: "asset-vid",
          class: { "focus-visible": _vm.galleryVersion == "legacy" },
          attrs: {
            width: _vm.isOldiOS === false ? _vm.item.imageWidth : false,
            height: _vm.isOldiOS === false ? _vm.item.imageHeight : false,
            allowfullscreen: "true",
            controllist: "none",
            playsinline: "",
            disableremoteplayback: "",
            disablePictureInPicture: "true",
            "x-webkit-airplay": "deny",
            preload: "auto",
            "data-poster": _vm.isPriority == false ? _vm.posterUrl : null,
            loop: _vm.loopAttribute,
            "aria-label": _vm.item.imageAlternativeText,
            autoplay: _vm.autoplayAttribute,
          },
          domProps: { muted: _vm.mutedAttribute },
          on: { click: _vm.videoToggle },
        },
        [
          _vm.mode === "full"
            ? [
                _vm.item.fullVideoMp4
                  ? _c("source", {
                      attrs: {
                        type: "video/mp4",
                        "data-src-observer": _vm.item.fullVideoMp4,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.fullVideoWebM
                  ? _c("source", {
                      attrs: {
                        type: "video/webm",
                        "data-src-observer": _vm.item.fullVideoWebM,
                      },
                    })
                  : _vm._e(),
              ]
            : _vm.mode === "thumbnail"
            ? [
                _vm.item.thumbnailVideoMp4
                  ? _c("source", {
                      attrs: {
                        type: "video/mp4",
                        src: _vm.item.thumbnailVideoMp4,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.thumbnailVideoWebM
                  ? _c("source", {
                      attrs: {
                        type: "video/webm",
                        src: _vm.item.thumbnailVideoWebM,
                      },
                    })
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            staticClass: "video-controls",
            class: {
              show:
                (_vm.mouseHovered ||
                  _vm.isParentFocused ||
                  _vm.hasControlFocus ||
                  _vm.showVideoControls) &&
                _vm.isPlaying == false,
            },
          },
          [
            _c(
              "button",
              {
                staticClass: "btnVideoPlayPause",
                class: { "focus-visible": _vm.galleryVersion == "legacy" },
                attrs: {
                  "aria-label": _vm.isPlaying
                    ? _vm.labels.videoPauseLabel
                    : _vm.labels.videoPlayLabel,
                  type: "button",
                  tabindex:
                    _vm.mouseHovered ||
                    _vm.isParentFocused ||
                    _vm.hasControlFocus ||
                    _vm.showVideoControls
                      ? "0"
                      : false,
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.videoToggle.apply(null, arguments)
                  },
                  focus: _vm.onFocus,
                  blur: _vm.onBlur,
                },
              },
              [
                _c("span", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isPlaying === false,
                      expression: "isPlaying === false",
                    },
                  ],
                  staticClass: "btnVideoPlay",
                  attrs: { "aria-hidden": _vm.isPlaying },
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isPlaying === true,
                      expression: "isPlaying === true",
                    },
                  ],
                  staticClass: "btnVideoPause",
                  attrs: { "aria-hidden": _vm.isPlaying === false },
                }),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.mode === "full"
            ? [
                _c("div", { staticClass: "gallery__videoControls-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "gallery__videoControls",
                      class: {
                        show:
                          (_vm.mouseHovered ||
                            _vm.isParentFocused ||
                            _vm.hasControlFocus) &&
                          _vm.isPlaying,
                      },
                    },
                    [
                      _c("button", {
                        class: _vm.isPlaying
                          ? "gallery__videoControls-pause"
                          : "gallery__videoControls-play",
                        attrs: {
                          tabindex: "0",
                          "aria-label": _vm.isPlaying
                            ? _vm.labels.videoPauseLabel
                            : _vm.labels.videoPlayLabel,
                        },
                        on: { click: _vm.videoToggle },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          ref: "videoProgressBar",
                          staticClass: "gallery__videoControls-progressBar",
                          attrs: {
                            role: "slider",
                            "aria-label": _vm.labels.videoProgressBarLabel,
                            "aria-valuemin": "0",
                            "aria-valuemax": _vm.videoDuration,
                            "aria-valuenow": _vm.videoCurrent,
                            "aria-valuetext": _vm.videoHumanAriaStr,
                          },
                          on: {
                            mousedown: _vm.progressBarClickDown,
                            mousemove: _vm.mouseMove,
                            touchmove: _vm.touchMoveHandler,
                          },
                        },
                        [
                          _c("div", {
                            staticClass:
                              "gallery__videoControls-progressBar-track",
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "gallery__videoControls-progressBar-head-positioner",
                              style: _vm.progressBarHeadPosition,
                            },
                            [
                              _c("div", {
                                ref: "videoProgressBarHead",
                                staticClass:
                                  "gallery__videoControls-progressBar-head",
                                attrs: {
                                  "aria-label":
                                    _vm.labels.videoProgressBarHeadLabel,
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("button", {
                        staticClass: "gallery__videoControls-fullscreen",
                        attrs: {
                          "aria-label": _vm.labels.videoFullScreenLabel,
                        },
                        on: { click: _vm.toggleFullscreen },
                      }),
                      _vm._v(" "),
                      _c("button", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasAudio,
                            expression: "hasAudio",
                          },
                        ],
                        staticClass: "gallery__videoControls-mute",
                        class: _vm.isMuted ? "unmute" : "mute",
                        attrs: {
                          "aria-hidden": _vm.hasAudio == false,
                          "aria-label": _vm.isMuted
                            ? _vm.labels.videoUnmuteLabel
                            : _vm.labels.videoMuteLabel,
                        },
                        on: {
                          click: function ($event) {
                            _vm.isMuted ? _vm.videoUnmute() : _vm.videoMute()
                          },
                        },
                      }),
                    ]
                  ),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }